export default __webpack_public_path__ + "static/friends-a0998e463f31097cb173515d0fab3065.gif";